import { useSelector } from "react-redux";
import Accordion from 'react-bootstrap/Accordion';
import { useState } from "react";


export const ChildQuModalStepTwo = ({ selectedQuestions, questions, triggerType, triggerValue, onChangeTriggerType,
    onChangeTriggerValue, onSelectChildQuestion, selectChildQu }) => {

    const [isQuestionsNotSelected, setIsQuestionsNotSelected] = useState(false);

    const reduxLanguageTranslations = useSelector(state => state.selectedLanguageTranslations.selectedLanguageTranslations);
    const reduxSelectedLanguage = useSelector(state => state.selectedLanguageTranslations.selectedLanguage);
    //console.log(selectedQuestions);

    return (
        <>
            <div>
                {
                    selectedQuestions.length > 0 ? selectedQuestions.map((item) => {

                        let detail = JSON.parse(item.questionDetail);
                        let answerOptions = detail.answerOptions;
                        //let answerOptions = 

                        const yesLabel = reduxSelectedLanguage === "en-GB" ? "Yes" : reduxSelectedLanguage === "fr-BE" ? "Oui" : "Ja";
                        const noLabel = reduxSelectedLanguage === "en-GB" ? "No" : reduxSelectedLanguage === "fr-BE" ? "Non" : "Nee";

                        return (

                            <div>
                                <div className="question-summary-container p-3 mb-4">
                                    <div className="mb-4">
                                        <p className="subtitle mb-0">{reduxLanguageTranslations ? reduxLanguageTranslations["selectionSummaryModalQuTitle"] : "Title of the question"}</p>
                                        <p className="modal-p-text-black mb-0">
                                            {detail ? detail["questionTitle-" + reduxSelectedLanguage] : ""}
                                        </p>
                                    </div>
                                    <div className="mb-4">
                                        <p className="subtitle mb-0">{reduxLanguageTranslations ? reduxLanguageTranslations["selectionSummaryModalDescQuestion"] : "Description of the question"}</p>
                                        <p className="modal-p-text-black mb-0">
                                            {detail ? detail["questionDescription-" + reduxSelectedLanguage] : ""}
                                        </p>
                                    </div>
                                    <div>
                                        <p className="subtitle mb-1">{reduxLanguageTranslations ? reduxLanguageTranslations["selectionSummaryModalAnsLabel"] : "Answers"}</p>
                                    </div>

                                    <div>
                                        {
                                            detail.answerType == 2 || detail.answerType == 3 && answerOptions.length > 0 ?
                                                answerOptions.map((option) => {
                                                    let label = option[`option${option.id}-${reduxSelectedLanguage}`];
                                                    return (
                                                        <div className="mb-2" key={option.id}>
                                                            <label className="modal-p-text-black asnwer-options-preview d-flex align-items-center mb-2 w-100 me-2 line-height-0" htmlFor={`answerOption${reduxSelectedLanguage.id}${option.id}`}>
                                                                <input className="custom-radio me-2" type="radio" name={`answerOption${reduxSelectedLanguage.id}`} id={`answerOption${reduxSelectedLanguage.id}${option.id}`} />
                                                                {
                                                                    label
                                                                }
                                                            </label>
                                                        </div>
                                                    )
                                                })
                                                :
                                                detail.answerType == 1 ?
                                                    <div className="d-flex col-4">
                                                        <label className="modal-p-text-black asnwer-options-preview d-flex align-items-center w-50 line-height-0 me-2" htmlFor={`radio${reduxSelectedLanguage.id}`}>
                                                            <input className="custom-radio me-2" type="radio" name={`radio${reduxSelectedLanguage.id}`} id={`radio${reduxSelectedLanguage.id}`} />
                                                            {reduxLanguageTranslations ? yesLabel : reduxLanguageTranslations["quesSummaryModalAnsRadioOptionYes"]}
                                                        </label>

                                                        <label className="modal-p-text-black asnwer-options-preview d-flex align-items-center w-50 line-height-0" htmlFor={`radio${reduxSelectedLanguage.id}${detail.answerType}`}>
                                                            <input className="custom-radio me-2" type="radio" name={`radio${reduxSelectedLanguage.id}`} id={`radio${reduxSelectedLanguage.id}${detail.answerType}`} />
                                                            {reduxLanguageTranslations ? noLabel : reduxLanguageTranslations["quesSummaryModalAnsRadioOptionNo"]}
                                                        </label>
                                                    </div>
                                                    :
                                                    detail.answerType == 4 || detail.answerType == 5 ?
                                                        <>
                                                            {
                                                                detail.answerType == 4 ?
                                                                    <input type="number" className={`form-control disabled mb-2 no-spinner`}
                                                                        onPaste={(e) => e.preventDefault()} disabled
                                                                    />
                                                                    :
                                                                    <input type="text" className={`form-control disabled mb-2`} disabled />
                                                            }

                                                        </>
                                                        :
                                                        <>
                                                            <input type="date" className="form-control disabled mb-2" disabled />
                                                        </>
                                        }
                                    </div>
                                </div>
                                <div className="d-flex justify-content-between mb-3">
                                    <p>Trigger Type:</p>
                                    <div className="">
                                        <select className={`form-select`} id="visitToSaleAfter" value={triggerType}
                                            onChange={onChangeTriggerType} disabled={true}>
                                            {
                                                detail.answerType == 4 ?
                                                    <option value="Gte">Gte</option>
                                                    :
                                                    <option value="Equals">Equals</option>
                                            }
                                        </select>
                                    </div>
                                </div>
                                <div className="d-flex justify-content-between mb-4">
                                    <p>Trigger Value:</p>
                                    <div className="">
                                        {
                                            detail.answerType == 4 ?
                                                <input type="number" className={`form-control mb-2`} value={triggerValue}
                                                    onChange={onChangeTriggerValue}
                                                />
                                                : detail.answerType == 2 || detail.answerType == 3 ?
                                                    <select className={`form-select`} id="visitToSaleAfter" value={triggerValue}
                                                        onChange={onChangeTriggerValue}>
                                                        <option value="">Select Trigger Value</option>
                                                        {
                                                            answerOptions.map((option, index) => {
                                                                let label = option[`option${option.id}-${reduxSelectedLanguage}`];

                                                                return (
                                                                    <option value={option.id} key={index}>{label}</option>
                                                                )
                                                            })
                                                        }
                                                    </select>
                                                    :
                                                    <select className={`form-select`} id="visitToSaleAfter" value={triggerValue}
                                                        onChange={onChangeTriggerValue}>
                                                        <option value="">Select Trigger Value</option>
                                                        <option value="true">Yes</option>
                                                        <option value="false">No</option>
                                                    </select>
                                        }
                                    </div>
                                </div>
                            </div>
                        )
                    })
                        :
                        <></>
                }

                <div>
                    <Accordion defaultActiveKey="1">
                        <Accordion.Item eventKey="1" className={`${isQuestionsNotSelected ? "border-red" : ""} mb-0`}>
                            <Accordion.Header>
                                Select Child Question
                                {/*<span className="required-icon">*</span> <img src={questionsLoader} width="25" className={`rotating-loader ms-2 ${isQuestionsLoaded == false ? "" : "d-none"}`} />*/}
                            </Accordion.Header>
                            <Accordion.Body className="question-accordion-body">
                                {
                                    questions.length > 0 ? questions.map((item) => {
                                        let isChecked = false;
                                        let detail = JSON.parse(item.questionDetail);
                                        let isFound = selectChildQu.some(q => q.id == item.id);

                                        if (isFound == true) {
                                            isChecked = isFound;
                                        }

                                        return (
                                            <label className={`modal-p-text-black question-div d-flex align-items-center mb-2 ${isChecked == true ? "question-bg" : ""}`} key={item.id} htmlFor={`checkbox${item.id}`}>
                                                <input className="form-check-input question-check-box me-2" type="checkbox" checked={isChecked} id={`checkbox${item.id}`} onChange={(e) => onSelectChildQuestion(e, item)} />
                                                {detail[`questionTitle-${reduxSelectedLanguage}`]}
                                            </label>
                                        )
                                    })
                                        :
                                        <>
                                        </>
                                }
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>
                    {/*<p className="text-red fs-small login-field-error">{requiredFieldMessage}</p>*/}
                </div>
            </div>
        </>
    )
}



